import { useApi, configApiRef } from '@backstage/core-plugin-api';
import React, { useEffect, useCallback, useState } from 'react';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import type { FieldValidation } from '@rjsf/utils';

import axios from 'axios';
import { ExistingRepoPickerState } from '../../interfaces';
import { ProjectsResponse } from '@internal/plugin-alm-services';
import ProjectPicker from '../repoUrlPicker/ProjectPicker';
import RepositoryPicker from './RepositoryPicker';

async function getProjects(config: any): Promise<ProjectsResponse> {
  try {
    const baseUrl = config.getString('backend.baseUrl');
    const response = await axios.get(`${baseUrl}/api/azure-devops/projects`);

    return response.data;
  } catch (error: any) {
    console.error(
      'Token request failed:',
      error.response?.data || error.message,
    );
    throw error;
  }
}

const ExistingRepoPicker = (props: any) => {
  const { onChange, rawErrors, formData } = props;
  const [projectsResponse, setProjectsResponse] =
    useState<ProjectsResponse>();
  const [state, setState] = useState<ExistingRepoPickerState>(formData ?? {});
  const { project, repoName } = state;
  const config = useApi(configApiRef);

  const fetchProjects = async () => {
    const res = await getProjects(config);
    setProjectsResponse(res);
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  useEffect(() => {
    onChange(state);
  }, [state, onChange]);

  const handleProjectChange = useCallback((newState: { project?: string }) => {
    // Reset the selected repository whenever the project changes, since
    // repositories are scoped to a single project.
    setState(prevState => ({
      ...prevState,
      project: newState.project,
      repoName: undefined,
      repositoryId: undefined,
      remoteUrl: undefined,
      defaultBranch: undefined,
    }));
  }, []);

  const handleRepositoryChange = useCallback(
    (newState: Partial<ExistingRepoPickerState>) => {
      setState(prevState => ({ ...prevState, ...newState }));
    },
    [],
  );

  return (
    <>
      <ProjectPicker
        project={project}
        projects={projectsResponse?.value.map(x => x.name)}
        onChange={handleProjectChange}
        rawErrors={rawErrors}
      />
      <RepositoryPicker
        project={project}
        repoName={repoName}
        onChange={handleRepositoryChange}
        rawErrors={rawErrors}
      />
    </>
  );
};

const validateExistingRepoPickerValidation = (
  value: ExistingRepoPickerState,
  validation: FieldValidation,
) => {
  if (!value?.project) {
    validation.addError(`- Azure Devops Project can not be empty`);
  }

  if (!value?.repoName) {
    validation.addError(`- Repository can not be empty`);
  }
};

export const ExistingRepoPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ExistingRepoPicker',
    component: ExistingRepoPicker,
    validation: validateExistingRepoPickerValidation,
  }),
);
